import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Button} from 'antd'
import DeleteModal from './DeleteModal'

import style from './controls.sass'

@inject('store') @observer
class Controls extends Component {
  state = {
    modal: false
  }
  openModal = () => {
    this.setState({modal: true})
  }
  closeModal = () => {
    this.setState({modal: false})
  }
  render() {
    const {stockFilter} = this.props.store
    const deleteDisabled = !stockFilter.list.selected.length
    return(
      <div styleName='wrapper'>
        <DeleteModal
          visible={this.state.modal}
          close={this.closeModal}
        />
        <Link to='stock-filters/builder'>
          <Button
            type='primary'
            icon='plus'
            styleName='create'
          >
            New Filter
          </Button>
        </Link>
        <Button
          type='danger'
          icon='delete'
          onClick={this.openModal}
          disabled={deleteDisabled}
        />
      </div>
    )
  }
}

export default Controls
